





import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Editor as TipTapViewer, Text } from 'tiptap';
import { Bold, Italic, Underline, Link, ListItem, HardBreak } from 'tiptap-extensions';
import {
  BulletListNode,
  HeadingNode,
  OrderedListNode,
  ParagraphNode,
  TextDocNode,
  MergeValueNode,
} from '@/editor/tiptap/nodes';
import { EHeadingLevel, EProsemirrorType } from '@/editor/types/enums';
import { ITextContentDoc, IMergeValues, IField } from '@/editor/types';
import ProsemirrorWrapper from '@/editor/editor-block/components/ProsemirrorWrapper.vue';

@Component({
  components: {
    ProsemirrorWrapper,
  },
})
export default class ProsemirrorViewerText extends Vue {
  @Prop() content: ITextContentDoc;
  @Prop() mergeValues: IMergeValues;
  @Prop() fields: IField[];
  @Watch('fields')
  @Watch('mergeValues')
  updateMergeValues() {
    const mergeTagNode = this.viewer.extensions.extensions.find(
      ext => ext.name === EProsemirrorType.MergeTag
    );
    if (!mergeTagNode) {
      return;
    }
    mergeTagNode.options.mergeValues = this.mergeValues;
    mergeTagNode.options.fields = this.fields;
  }
  @Watch('content') setContent() {
    if (JSON.stringify(this.viewer.getJSON()) === JSON.stringify(this.content)) {
      return;
    }
    this.viewer.setContent(this.content);
  }

  viewer: TipTapViewer | null = null;

  get textViewer() {
    return {
      content: this.content,
      editable: false,
      disableInputRules: false,
      disablePasteRules: false,
      useBuiltInExtensions: false,
      extensions: [
        new TextDocNode(),
        new ParagraphNode(),
        new Text(),
        new Bold(),
        new Italic(),
        new Underline(),
        new OrderedListNode(),
        new BulletListNode(),
        new ListItem(),
        new MergeValueNode({
          mergeValues: this.mergeValues,
          fields: this.fields,
        }),
        new Link({
          target: '_blank',
        }),
        new HeadingNode({
          levels: [
            EHeadingLevel.Heading1,
            EHeadingLevel.Heading2,
            EHeadingLevel.Subheading,
            EHeadingLevel.Label,
          ],
        }),
        new HardBreak(),
      ],
      dropCursor: {
        color: 'transparent',
      },
    };
  }

  mounted() {
    this.viewer = new TipTapViewer(this.textViewer);
  }
}
